import Emitter from 'mitt'

type Events = {
  getNewsBanners: null
  getNewsCategories: null
  getNewsDetail: null
  getJobIntro: null
  getGuidelineCategories: null
  getGuidelineDetail: null
  getKolList: null
  getSchedule: null
  getMVP: null
  getCategories: null
  getLeaderboard: null
  getGuildCount: null
  getResourceOfVideos: null
  getHomeVSVideos: null
  getMusicList: null
  getVSNews: null
}

const emitter = Emitter<Events>()

/**
 * 订阅事件（用本地语言重新请求接口数据）
 */
export const refetchDataByLocalLang = () => {
  emitter.emit('getNewsBanners', null)
  emitter.emit('getNewsCategories', null)
  emitter.emit('getNewsDetail', null)
  emitter.emit('getJobIntro', null)
  emitter.emit('getGuidelineCategories', null)
  emitter.emit('getGuidelineDetail', null)
  emitter.emit('getKolList', null)
  emitter.emit('getSchedule', null)
  emitter.emit('getMusicList', null)
  emitter.emit('getCategories', null)
  emitter.emit('getLeaderboard', null)
  emitter.emit('getVSNews', null)
  emitter.emit('getMVP', null)
  emitter.emit('getResourceOfVideos', null)
  emitter.emit('getHomeVSVideos', null)
}
export default emitter
